<div class="w-100 position-relative">
    <div class="input-group" autocomplete="off">
        <div class="input-group-prepend">
            <div class="input-group-text input-group-text-sm" style="width: 2.2rem;">
                <div class="activityTypeSelectedIcon"><i class="{{ selectedType?.icon }}"></i></div>
            </div>
        </div>
        <input [attr.id]="inputId" type="text" class="form-control form-control-sm activityTypeInput" [ngModel]="selectedType?.name" (keydown)="preventKey($event)" (keyup)="filter($event)" (click)="selectInputText(); delayOpen()" autocomplete="off" placeholder="{{ 'Standard.NoneChosen' | translate }}">
        <div class="input-group-append">
            <div class="input-group-text input-group-text-sm cursor-pointer">
                <span *ngIf="!dropOpen" (click)="delayOpen()"><i class="fa-solid fa-arrow-down"></i></span>
                <span *ngIf="dropOpen" (click)="dropOpen = false"><i class="fa-solid fa-arrow-up"></i></span>
            </div>
        </div>
    </div>
    <div class="position-absolute activityTypesDropDown" *ngIf="dropOpen">
        <div class="d-flex align-items-center" *ngFor="let t of types" (click)="onSelect(t)">
            <div style="width:2rem;text-align: center;"><i class="{{ t.icon }}"></i></div>
            <div class="ml-3" >{{ t.name }}</div>
        </div>
    </div>
</div>
